import React from "react";
import { PageHeader } from "@finitless/shared/components";
import { useTranslation } from "react-i18next";

const VoiceCallsPage = ({ selectedBrand }) => {
  const { t } = useTranslation("reports");

  return (
    <div className="space-y-6">
      <PageHeader
        title={t("voiceCalls.header.title")}
        subtitle={t("voiceCalls.header.subtitle", {
          name: selectedBrand?.name || t("voiceCalls.header.defaultBusiness"),
        })}
      />

      <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
        <div className="py-12 text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
            <svg
              className="h-8 w-8 text-green-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
              />
            </svg>
          </div>
          <h3 className="mb-2 text-lg font-medium text-gray-900">
            {t("voiceCalls.card.title")}
          </h3>
          <p className="mb-6 text-gray-600">{t("voiceCalls.card.subtitle")}</p>
          <div className="mx-auto grid max-w-2xl grid-cols-1 gap-4 md:grid-cols-3">
            <div className="rounded-lg bg-gray-50 p-4">
              <div className="text-2xl font-semibold text-green-600">324</div>
              <div className="text-sm text-gray-600">
                {t("voiceCalls.stats.totalCalls")}
              </div>
            </div>
            <div className="rounded-lg bg-gray-50 p-4">
              <div className="text-2xl font-semibold text-blue-600">3.2m</div>
              <div className="text-sm text-gray-600">
                {t("voiceCalls.stats.avgDuration")}
              </div>
            </div>
            <div className="rounded-lg bg-gray-50 p-4">
              <div className="text-2xl font-semibold text-purple-600">92%</div>
              <div className="text-sm text-gray-600">
                {t("voiceCalls.stats.resolutionRate")}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VoiceCallsPage;
